import { CustomMarker } from "./CustomMarker";
export default CustomMarker;
